import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Icon, TabBar, Title, Navigation } from '@fnacdarty/back-office-ui';
import { useTheme } from 'styled-components';
import { BrandHeadBar } from '../../../../layouts';

import ActivityInfo from '../../../activity/components/ActivityInfo';
import ActivityFile from '../../../activity/components/ActivityFile';

import CalendarContainer from '../../../planning/components/CalendarContainer';
import Settings from '../../../../routes/settings';

import {
	getActivitiesList,
	getUniqueResourcesFromActivities,
} from '../../../activity/utils/activity';

import {
	StyledCircleButton,
	StyledContainer,
	StyledHeader,
	StyledCalendarPanelContent,
	StyledActivityPanelContent,
	StyledPanelDetails,
	StyledTabContainer,
	StyledNavigation,
} from './index.styled';
import ActivityContainer from '../../../activity/components/ActivityContainer';
import NavBar from '../../../../layouts/NavBar';

const HomeContainer = ({
	currentTab,
	sectors,
	skills,
	resources,
	changeFiliale,
	setChangeFiliale,
	setRefreshData,
	refreshData,
	canEditPlanning,
}) => {
	const theme = useTheme();
	const [activities, setActivities] = useState(null);
	const [showDetails, setShowDetails] = useState(true);
	const [selectedActivity, setSelectedActivity] = useState(null);
	const [activityTab, setActivityTab] = useState('details');
	const [newComment, setNewComment] = useState(null);

	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;

	const setCurrentActivity = (activity, firstShow = true) => {
		setShowDetails(true);
		if (!firstShow) {
			setShowDetails(false);
		}
		setSelectedActivity(activity);
	};

	const urlTab = window.location.pathname.split('/')[1];
	const [currentTabMob, setCurrentTabMob] = React.useState(
		urlTab || 'activities',
	);

	const [filters, setFilters] = useState({
		search: '',
		sort: {
			by: {
				label: '',
				value: '',
				path: '',
			},
			order: 'asc',
		},
		resources: [],
		treatments: [
			{
				label: 'Traité',
				code: 'treated',
				selected: true,
			},
			{
				label: 'Non traité',
				code: 'untreated',
				selected: true,
			},
		],
	});

	const updateSearch = (newSearch) => {
		setFilters({
			...filters,
			search: newSearch.target.value,
		});
	};
	const AUTH_VAR = `${process.env.REACT_APP_BASE_NAME}`;
	const activeFiltre = window.localStorage.getItem(`${AUTH_VAR}_filiale`)
		? JSON.parse(window.localStorage.getItem(`${AUTH_VAR}_filiale`))?.value
		: 1;

	useEffect(() => {
		const getActivities = async () => {
			const res = await getActivitiesList(activeFiltre);

			if (res) {
				setActivities(res);
				if (res && res?.length > 0) {
					const uniqueResources =
						getUniqueResourcesFromActivities(res);
					setFilters({
						...filters,
						resources: uniqueResources,
					});
				} else {
					setActivities([]);
					setFilters({
						...filters,
						resources: [],
					});
				}
			} else {
				setActivities([]);
			}
		};

		if (!activities || changeFiliale || refreshData) {
			setActivities(null);
			getActivities();
		}
	}, [changeFiliale, refreshData]);

	const updateActivity = (activity) => {
		const newActivities = activities?.map((item) => {
			if (item.id === activity.id) {
				return activity;
			}
			return item;
		});
		setActivities(newActivities);
	};
	return (
		<>
			{!isVersionPC() && (
				<>
					<BrandHeadBar />
					{currentTabMob === 'activities' && (
						<ActivityContainer
							isVersionPC={isVersionPC}
							activities={activities}
							selectedActivity={selectedActivity}
							setSelectedActivity={setCurrentActivity}
							updateActivity={updateActivity}
							filters={filters}
							setFilters={setFilters}
							updateSearch={updateSearch}
							currentTabMob={currentTabMob}
						/>
					)}
					{currentTabMob === 'planning' && (
						<CalendarContainer
							selectedActivity={selectedActivity}
							setSelectedActivity={setCurrentActivity}
							setNewComment={setNewComment}
							sectors={sectors}
							skills={skills}
							resources={resources}
							newComment={newComment}
							changeFiliale={changeFiliale}
							isVersionPC={isVersionPC}
							refreshData={refreshData}
							canEditPlanning={canEditPlanning}
						/>
					)}
					{currentTabMob === 'settings' && <Settings></Settings>}
					{currentTabMob !== 'settings' &&
						selectedActivity &&
						showDetails && (
							<StyledPanelDetails
								$isVisible={selectedActivity && showDetails}
								currentTabMob={currentTabMob === 'planning'}
							>
								<StyledHeader isVersionPC={isVersionPC()}>
									<StyledCircleButton
										color={theme.colors.primary}
										onClick={() => setShowDetails(false)}
										isVersionPC={isVersionPC()}
									>
										<Icon name="x" width={20} />
									</StyledCircleButton>
								</StyledHeader>
								<StyledTabContainer>
									<TabBar
										currentTab={activityTab}
										setCurrentTab={setActivityTab}
										tabs={[
											{
												label: 'Détails',
												value: 'details',
												notification: false,
												notificationCount: 0,
											},
											{
												label: 'Documents',
												value: 'files',
												notification: false,
												notificationCount: 0,
											},
										]}
									/>
								</StyledTabContainer>
								{activityTab === 'details' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityInfo
												activity={selectedActivity}
												setSelectedActivity={
													setSelectedActivity
												}
												updateActivity={updateActivity}
												newComment={newComment}
												setNewComment={setNewComment}
											/>
										</StyledContainer>
									)}
								{activityTab === 'files' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityFile
												activity={selectedActivity}
												setActivity={setCurrentActivity}
											/>
										</StyledContainer>
									)}
							</StyledPanelDetails>
						)}
					<StyledNavigation>
						<Navigation
							currentTab={currentTabMob}
							setCurrentTab={setCurrentTabMob}
							tabs={[
								{
									icon: 'clipboard-list',
									label: 'Activités',
									notification: false,
									notificationCount: 0,
									value: 'activities',
								},
								{
									icon: 'calendar',
									label: 'Calendrier',
									notification: false,
									notificationCount: 0,
									value: 'planning',
								},

								{
									icon: 'cog',
									label: 'Paramètres',
									notification: false,
									notificationCount: 0,
									value: 'settings',
								},
							]}
						/>
					</StyledNavigation>
				</>
			)}
			{isVersionPC() && (
				<>
					<NavBar
						currentTab={currentTab}
						setChangeFiliale={setChangeFiliale}
						sectors={sectors}
						skills={skills}
						resources={resources}
						setRefreshData={setRefreshData}
					/>
					{currentTab === 'activities' && (
						<StyledActivityPanelContent>
							<ActivityContainer
								isVersionPC={isVersionPC}
								activities={activities}
								selectedActivity={selectedActivity}
								setSelectedActivity={setCurrentActivity}
								updateActivity={updateActivity}
								filters={filters}
								setFilters={setFilters}
								updateSearch={updateSearch}
							/>
							<StyledPanelDetails
								$isVisible={selectedActivity && showDetails}
							>
								<StyledHeader>
									<Title level={2}>
										Détails de l&apos;activité
									</Title>
									<StyledCircleButton
										color={theme.colors.primary}
										onClick={() => setShowDetails(false)}
									>
										<Icon name="x" width={20} />
									</StyledCircleButton>
								</StyledHeader>
								<StyledTabContainer>
									<TabBar
										currentTab={activityTab}
										setCurrentTab={setActivityTab}
										tabs={[
											{
												label: 'Détails',
												value: 'details',
												notification: false,
												notificationCount: 0,
											},
											{
												label: 'Documents',
												value: 'files',
												notification: false,
												notificationCount: 0,
											},
										]}
									/>
								</StyledTabContainer>
								{activityTab === 'details' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityInfo
												activity={selectedActivity}
												setSelectedActivity={
													setSelectedActivity
												}
												updateActivity={updateActivity}
												newComment={newComment}
												setNewComment={setNewComment}
											/>
										</StyledContainer>
									)}
								{activityTab === 'files' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityFile
												activity={selectedActivity}
												setActivity={setCurrentActivity}
											/>
										</StyledContainer>
									)}
							</StyledPanelDetails>
						</StyledActivityPanelContent>
					)}
					{currentTab === 'planning' && (
						<StyledCalendarPanelContent>
							<CalendarContainer
								selectedActivity={selectedActivity}
								setSelectedActivity={setCurrentActivity}
								setNewComment={setNewComment}
								sectors={sectors}
								skills={skills}
								resources={resources}
								newComment={newComment}
								changeFiliale={changeFiliale}
								isVersionPC={isVersionPC}
								refreshData={refreshData}
								canEditPlanning={canEditPlanning}
							/>
							<StyledPanelDetails
								$isVisible={selectedActivity && showDetails}
							>
								<StyledHeader>
									<Title level={2}>
										Détails de l&apos;activité
									</Title>
									<StyledCircleButton
										color={theme.colors.primary}
										onClick={() => setShowDetails(false)}
									>
										<Icon name="x" width={20} />
									</StyledCircleButton>
								</StyledHeader>
								<StyledTabContainer>
									<TabBar
										currentTab={activityTab}
										setCurrentTab={setActivityTab}
										tabs={[
											{
												label: 'Détails',
												value: 'details',
												notification: false,
												notificationCount: 0,
											},
											{
												label: 'Documents',
												value: 'files',
												notification: false,
												notificationCount: 0,
											},
										]}
									/>
								</StyledTabContainer>
								{activityTab === 'details' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityInfo
												activity={selectedActivity}
												setSelectedActivity={
													setSelectedActivity
												}
												updateActivity={updateActivity}
												newComment={newComment}
												setNewComment={setNewComment}
											/>
										</StyledContainer>
									)}
								{activityTab === 'files' &&
									selectedActivity && (
										<StyledContainer>
											<ActivityFile
												activity={selectedActivity}
												setActivity={setCurrentActivity}
											/>
										</StyledContainer>
									)}
							</StyledPanelDetails>
						</StyledCalendarPanelContent>
					)}
				</>
			)}
		</>
	);
};

HomeContainer.propTypes = {
	currentTab: PropTypes.string,
	sectors: PropTypes.array,
	skills: PropTypes.array,
	resources: PropTypes.array,
	setChangeFiliale: PropTypes.func,
	changeFiliale: PropTypes,
	setRefreshData: PropTypes.func,
	refreshData: PropTypes.bool,
	canEditPlanning: PropTypes.bool,
};

export default HomeContainer;
